import { render, staticRenderFns } from "./ModalNurseAction.vue?vue&type=template&id=23a8f4a1"
import script from "./ModalNurseAction.vue?vue&type=script&lang=js"
export * from "./ModalNurseAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports